import type { SVGProps } from 'react';

export const User = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" {...props}>
    <path
      d="M8.00025 9.7998C10.264 9.79985 12.3811 10.4269 14.1877 11.5166C15.2518 12.1584 15.2518 13.6394 14.1877 14.2812C12.381 15.3711 10.2642 15.999 8.00025 15.999C5.73627 15.999 3.61853 15.3711 1.81177 14.2812C0.748342 13.6393 0.748237 12.1584 1.81177 11.5166C3.61854 10.4268 5.73635 9.7998 8.00025 9.7998ZM7.99927 0C10.2083 0 11.9993 1.79097 11.9993 4C11.9992 6.20894 10.2082 8 7.99927 8C5.79051 7.99976 4.00036 6.20879 4.00025 4C4.00025 1.79112 5.79045 0.000235393 7.99927 0Z"
      fill="currentcolor"
    />
  </svg>
);
